import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "../assets/styles/product.css";
import parse from "html-react-parser";


import Cdil_power from "../assets/images/power-button.png";
import Cdil_car from "../assets/images/car.png";
import Cdil_radio from "../assets/images/radio-tower.png";
import { useDispatch } from 'react-redux'
import { setEnquiryProduct, setShowEnquireModal } from "../context/data/modalSlice";

const Product = () => {
  const { categoryId, subcategoryId, productName } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch()
  const [pdfUrl, setPdfUrl] = useState(null);



  /* ================= API ================= */
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/frontend/product/${categoryId}/${subcategoryId}/${productName}`,
        {
          params: {
            sendPackageCategorySubcategoryAndProductInformation: true,
            isLatest: true,
          },
        }
      )
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [categoryId, subcategoryId, productName]);

  /* ================= LOAD POD PDF ================= */
  useEffect(() => {
    if (!data?.packageDetails?.length) return;

    const loadPOD = async () => {
      try {
        const pkg = data.packageDetails[0];

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/frontend/packages/imageOrPod`,
          {
            params: {
              packagePodName: pkg.packagePod,
              type: "pod",
            },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (err) {
        console.error("POD load failed", err);
      }
    };

    loadPOD();

    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [data]);
  /* ================= LOADING & ERROR ================= */

  if (loading) return <p className="loading">Loading...</p>;
  if (!data) return <p className="loading">Product Not Found</p>;

  /* ================= HELPERS ================= */

  const getField = (fieldId) =>
    data.fieldData.find((f) => f.id === fieldId);

  const getUnitSymbol = (unitId) =>
    data.units.find((u) => u.id === unitId)?.symbol || "";

  const formatValue = (item) => {
    const field = getField(item.fieldId);
    if (!field) return "-";

    const value =
      item.value !== null && item.value !== undefined
        ? item.value
        : item.charValue;

    const unit = getUnitSymbol(field.unitId);
    return `${value} ${unit}`.trim();
  };

  /* ================= DOWNLOADS ================= */

 const getPodImageSrc = (pkg) => {
  if (!pkg.packagePodImageData) return null;

  const type = pkg.packagePodImageType || "image/png";
  return `data:${type};base64,${pkg.packagePodImageData}`;
};


  const downloadDatasheet = () => {
    if (data.pdfDataSheet) {
      window.open(data.pdfDataSheet, "_blank");
    } else {
      alert("Datasheet not available for this product.");
    }
  };

  const downloadPackagePOD = async (pkg) => {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/frontend/packages/imageOrPod`,
        params: {
          packagePodName: pkg.packagePod,
          type: "pod",
        },
        responseType: "blob",
      });

      const url = URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      window.open(url, "_blank");
    } catch (err) {
      alert("POD not available");
    }
  };

  /* ================= UI ================= */

const getFieldGroupLabel = (fieldId) => {
  const group = data.fieldGroupData?.find(
    (g) => Number(g.id) === Number(fieldId)
  );

  return group?.fieldGroupLabel || "-";
};

  return (
    <div className="product-page">

      {/* BREADCRUMB */}
      <ol className="breadcrumb">
        <li><Link to="/">Home</Link></li>
        <li><Link to={`/table/category/${data.categoryName}/all`}>{data.categoryName}</Link></li>
        <li><Link to={`/table/category/${data.categoryName}/${data.subcategoryName}`}>{data.subcategoryName}</Link></li>
        <li className="active">{productName}</li>
      </ol>

      {/* TOP */}
      <div className="product-top">
        <div className="product-image"> 
          <img
            src={`data:${data.packageDetails[0]?.imageType};base64,${data.packageDetails[0]?.imageFile}`}
            alt={productName}
          />
          <span className="package-tag" style={{ fontFamily: "system-ui" }}>
            {data.packageDetails[0]?.packageName}
          </span>
        </div>

        <div className="product-info">
          <div className="product-title">
            <h1>{productName}</h1>
            <span className="status active">Active</span>
          </div>

          <p className="description">
            {data.subcategoryName}
          </p>

          {/* KEY STATS */}
          {(() => {
            const keyGroups = data.fieldGroupsInSubcategory
              ?.sort((a, b) => a.ordering - b.ordering)
              .filter(group => {
                const fg = data.fieldGroupData.find(g => g.id === group.fieldGroupId);
                return fg?.fieldGroupLabel?.toLowerCase() !== 'device';
              })
              .slice(0, 4);
            if (!keyGroups?.length) return null;
            return (
              <div className="key-stats">
                {keyGroups.map((group) => {
                  const parameter = data.fieldGroupData.find(g => g.id === group.fieldGroupId)?.fieldGroupLabel;

                  // Find first field in this group that actually has a value for this product
                  const fieldsInGroup = data.fieldsInFieldGroups
                    .filter(f => f.fieldGroupId === group.fieldGroupId)
                    .sort((a, b) => a.ordering - b.ordering);
                  const firstField = fieldsInGroup.find(f => {
                    const v = data.productFieldsValues.find(pv => pv.fieldId === f.fieldId);
                    return v && (v.value != null || v.charValue != null);
                  });
                  if (!firstField) return null;

                  const fieldInfo = data.fieldData.find(f => f.id === firstField.fieldId);
                  const valueObj = data.productFieldsValues.find(v => v.fieldId === firstField.fieldId);
                  const unit = data.units.find(u => u.id === fieldInfo?.unitId)?.symbol || "";
                  const value = valueObj.value ?? valueObj.charValue ?? "—";
                  return (
                    <div className="stat-card" key={group.fieldGroupId}>
                      <div className="stat-label">{parse(parameter || "—")}</div>
                      <div className="stat-value">{value}</div>
                      {unit && <div className="stat-unit">{unit}</div>}
                    </div>
                  );
                })}
              </div>
            );
          })()}

          <div className="cta">
            <button className="btn primary" onClick={downloadDatasheet}>
              📄 Download Datasheet
            </button>
            <button className="btn outline"  style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      document.body.style.overflow = 'hidden'
                                      dispatch(setShowEnquireModal(true))
                                      dispatch(setEnquiryProduct({
                                        productId: data.id,
                                        productName: data[Object.keys(data).find(key => key.indexOf('device') === 0)],
                                        categoryId: data.categoryId,
                                        subcategoryId: data.subcategoryId,
                                      }))
                                    }}>Request Sample</button>
          </div>
        </div>
      </div>

      {/* PARAMETRICS */}
      <section className="section" id="specs">
        <div className="tabs">
          <a href="#specs" className="tab active">Specifications</a>
          <a href="#packages" className="tab">Packages</a>
        </div>

        <h2 className="section-title">Specifications</h2>

        <div className="table-card">
   <table>
  <thead>
    <tr>
      <th>Parameter</th>
      <th>Condition</th>
      <th>Value</th>
    </tr>
  </thead>

  <tbody>
    {data.fieldGroupsInSubcategory
      ?.sort((a, b) => a.ordering - b.ordering)
      .map((group) => {

        /* PARAMETER NAME */
        const parameter =
          data.fieldGroupData.find(
            (g) => g.id === group.fieldGroupId
          )?.fieldGroupLabel || "-";

        /* CONDITIONS UNDER PARAMETER */
        const fields =
          data.fieldsInFieldGroups
            .filter((f) => f.fieldGroupId === group.fieldGroupId)
            .sort((a, b) => a.ordering - b.ordering);

        if (!fields.length) return null;

        return fields.map((field, index) => {
          const fieldInfo = data.fieldData.find(
            (f) => f.id === field.fieldId
          );

          const valueObj = data.productFieldsValues.find(
            (v) => v.fieldId === field.fieldId
          );

          if (!valueObj) return null;

          const unit =
            data.units.find(
              (u) => u.id === fieldInfo?.unitId
            )?.symbol || "";

          const condition =
            fieldInfo?.fieldLabel?.trim() || "—";

          const value =
            valueObj.value ?? valueObj.charValue ?? "—";

          return (
            <tr key={`${group.fieldGroupId}-${field.fieldId}`}>
              {/* Show parameter only on first row */}
              <td>{index === 0 ? parse(parameter) : ""}</td>

              <td style={{ textAlign: "center" }}>
                {parse(condition)}
              </td>

              <td style={{ textAlign: "center" }}>
                {value} {unit}
              </td>
            </tr>
          );
        });
      })}
  </tbody>
</table>



        </div>
      </section>

      {/* PACKAGE DETAILS */}
      <section className="section" id="packages">
        <h2 className="section-title">Package Details & Ordering</h2>
        <p className="description">
          Standard configurations available for immediate shipping.
        </p>

        {data.packageDetails.map((pkg, i) => (
          <div className="package-wrapper" key={i}>

            <div className="package-info">
              <div className="package-row">
                <div>
                  <span className="label" >PACKAGE NAME</span>
                  <h4 style={{ fontStyle: "normal",fontSize: "14px" }}>{pkg.packageName}</h4>
                </div>
                <div>
                  <span className="label">DESCRIPTION</span>
                  <p style={{ fontStyle: "normal", color: "rgb(15 23 42 / var(--tw-text-opacity, 1))", fontWeight: 600, fontSize: "16px", margin: "5px"}}>{pkg.packageDesc}</p>
                </div>
              </div>

              <div className="documents">
                <span className="label">DOCUMENTS</span>
                <div className="doc-links">
                  <button
                    className="doc-link" style={{ backgroundColor: "#f0f0f0" }}
                    onClick={() => downloadPackagePOD(pkg)}
                  >
                    📄 POD (Package Outline Drawing)
                  </button>
                  {/*<button className="doc-link" disabled style={{ backgroundColor: "#f0f0f0" }}>
                    🧊 3D Model
                  </button>*/}
                </div>
              </div>

              <div className="ordering-box">
                <span className="label">Ordering Information</span>
                <div className="ordering-row">
                  {/*<span>Tape & Reel (3000 pcs)</span>*/}
                  <strong>{productName}</strong>
                </div>
              </div>
            </div>

            <div className="package-image">
              {pdfUrl && (
                <iframe
                  src={`${pdfUrl}#zoom=page-fit&toolbar=0`}
                  title="POD Datasheet"
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "360px",
                    border: "none",
                    borderRadius: "0",
                    background: "#fff",
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </section>


    </div>
  );
};

export default Product;
